import {IMenuItemAction, IMenuItemExecuteOptions} from "./menu-item-action.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {
    IMenuItemConfigReader, MenuItemConfigurationExtended
} from "../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {MenuItemKey} from "../configurations/config-data-sections/generated-config-const";
import {NullableUndefinedString} from "../../../common/types/nullable-types";

export abstract class MenuItemActionBase implements IMenuItemAction {
    constructor(public readonly key: MenuItemKey,
                private readonly configReader: IMenuItemConfigReader,
                protected readonly services: IServiceFactoryExtended) {
    }


    protected abstract _onClick(options?: IMenuItemExecuteOptions): Promise<void>;

    async execute(options?: IMenuItemExecuteOptions): Promise<void> {
        const sideMenu = await this.services.sideMenu;
        await sideMenu.closeMobileMenu();
        (await this.services.userMenu).closeMenu();
        this.services.hybrid.closeSecondWebView();
        const drawer = await this.services.drawer;
        drawer.right.closeDrawer();
        const analytics = this.config.analytics;
        if(analytics) {
            this.services.analytics.sendOrbitUserFlowEvent(analytics.category, analytics.action, analytics.label);
        }
        await this._onClick();
    }

    private _config: MenuItemConfigurationExtended | null = null;

    protected get config(): MenuItemConfigurationExtended {
        if(!this._config) {
            this._config = this.configReader.getMenuItemConfig(this.key);
        }

        return this._config;
    }

    get isMatchToCurrentUrl(): boolean {
        return false;
    }

    getLinkUrl(): NullableUndefinedString {
        if(!this.config.linkId) {
            return null;
        }
        return this.services.linksNavigation.getLinkUrl(this.config.linkId);
    }

}